const CFX = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="10" fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.99987 6.00013L4 9.00022L4.00009 9.46508C4.00018 9.72071 4.01337 10.365 4.0294 10.8968L4.05863 11.8637L7.02945 8.89306L10.0003 5.92251L12.9668 8.8893C14.5984 10.521 15.9483 11.8561 15.9667 11.8561C15.985 11.8561 16 11.2134 16 10.4279V8.99973L12.9999 5.99987L9.99978 3L6.99987 6.00013ZM7.6972 10.9707L5.39506 13.2732L7.69764 15.5757L10.0002 17.8783L12.3025 15.5757L14.6049 13.2731L13.8855 12.5537L13.1661 11.8343L11.5827 13.4173L9.99934 15.0002L9.13653 14.1365L8.27373 13.2729L9.83426 11.7119C10.6926 10.8533 11.3948 10.1308 11.3948 10.1063C11.3948 10.0817 11.0808 9.74816 10.6971 9.36496L9.99934 8.66825L7.6972 10.9707Z"
      fill="black"
    />
  </svg>
);
export default CFX;
